import { render, staticRenderFns } from "./LoginProductIndex.vue?vue&type=template&id=3b4bf164&scoped=true&"
import script from "./LoginProductIndex.vue?vue&type=script&lang=js&"
export * from "./LoginProductIndex.vue?vue&type=script&lang=js&"
import style0 from "./LoginProductIndex.vue?vue&type=style&index=0&id=3b4bf164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4bf164",
  null
  
)

export default component.exports